module.exports = __webpack_public_path__ + "img/terms-and-conditions-icon.9773ef94.svg";